<div class="container user-actions d-flex justify-content-end items-center gap-md">
    @for (item of visibleActions(); track item.permission) {
    <button mat-button class="action-btn" (click)="item.action()">
        <mat-icon [class]="item.class">{{ item.icon }}</mat-icon>
        <span>{{ item.label | translate }}</span>
    </button>
    }
</div>